var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ca-input',{ref:"codeInput",attrs:{"on-blur":_vm.checkStockCode,"custom-validations":_vm.codeValidation,"required":""},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}})}
var staticRenderFns = []

export { render, staticRenderFns }